@if (!authReady()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}
@if (authReady()) {
  @if (showLoader()) {
    <section class="loaderwrp">
      <div class="scale-loader">
        <div class="dot-pulse"></div>
      </div>
    </section>
  }
  <app-header (languageChanged)="languageChanged($event)"></app-header>
  <div class="container relative height-100vh">
    <div class="inner-content-wrap">
      <form [formGroup]="landingFormGroup">
        <div>
          <h1 class="h1 farro-header mb8">{{welcomeText}}</h1>
          <p class="para-text mb44 mb28-700">{{greatToHaveYou}}</p>
          <h2 class="head_text mb8">{{modeOfCounselling}}</h2>
          <div class="custom_chip mb44 mb28-700">
            <mat-chip-listbox  aria-label="Select counselling mode" class="login_d-flex" (click)="counsellingModeSelected()" formControlName="counsellingMode" id="counsellingMode">
              <mat-chip-option class="tag" value="In-Person" id="inPerson">In person</mat-chip-option>
              <mat-chip-option class="tag" value="Virtual" id="virtual">Virtual counselling</mat-chip-option>
            </mat-chip-listbox>
            @if (submitted && notSelected && !isCounsellingModeSelected) {
              <div class="err">{{validationErrorText}}</div>
            }
          </div>
          <div class="login-btn-cnr">
            <button class="login-btn" (click)="signinPage()" id="next">{{nextButton}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
